// Copyright (c) 2025. CYBERKOALA LLC. All Rights Reserved.
// Proprietary license.

import { createContext } from 'react';
import { socketStore } from '@/stores/use-socket-store.ts';

type SocketContextType = {
  socket: typeof socketStore.socket;
  isConnected: boolean;
};

export const SocketContext = createContext<SocketContextType>({
  socket: null,
  isConnected: false,
});
